import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_12: FaireProductEntity = {
  token: "caden-lane-12",
  type: "product",
  name: "Lane Convertible Diaper Bag Tote | Sand",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/4dde1fc71e75c0e73bcd2c2e74c9da64731ba94f09ccf0634b1acc48ecf46443.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 32,
  msrpDollars: 64,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_baby-accessories"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
